/*
 * @Author: sunmingyu 17611322367@163.com
 * @Date: 2024-03-23 15:04:55
 * @LastEditors: sunmingyu 17611322367@163.com
 * @LastEditTime: 2024-03-26 11:37:07
 * @FilePath: /management-login/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@web/utils'
import { ElMessageBox } from 'element-plus'
import 'element-plus/es/components/message-box/style/css'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home.vue')
    }
  ]
})
router.beforeEach(async to => {
  // 从哪个跳转到登录系统的url
  let redirect: string = (to.query.redirect || '') as string
  // 本地localhost才有值，用于判断其他系统和登录系统本地run的值是否一致(不具体判断其他系统到底是哪个了吧?)
  let env: string = (to.query.env || '') as string
  // 本地localhost判断环境变量是否一致
  if (env && decodeURIComponent(env) !== import.meta.env.VITE_MODE) {
    ElMessageBox.confirm(
      '本地启动的统一登录系统与其他应用系统(gundam,crm,sap,seller,fortune)环境不一致，请统一环境后再进行登录。错误示例: npm run dev:dev 和 npm run dev:test',
      'Warning',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
      .then(() => {})
      .catch(() => {})
    return
  }
  if (getToken(import.meta.env.VITE_MODE)) {
    try {
      //token虽然有值，判断是否失效
      const response = await fetch(import.meta.env.VITE_API_PREFIX + '/getInfo', {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + getToken(import.meta.env.VITE_MODE)
        }
      })
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      const data = await response.json()
      // token未失效
      if (data.code === 2000) {
        // 没有redirect参数默认去到管理端gundam
        if (!redirect) {
          if (/local/.test(location.origin)) {
            window.location.replace('http://localhost:8080/gundam/')
          } else {
            window.location.replace(import.meta.env.VITE_ORIGIN_GUNDAM)
          }
          return
        }
        window.location.replace(decodeURIComponent(redirect as string))
      } else {
        // 失效不做处理，重新登录即可
        console.log('token虽然有值，但是已经失效了')
      }
    } catch (err) {
      console.log(err)
    }
  }
})
export default router
